import * as React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardContainer from './containers/DashboardContainer';
import useCurrentUser from './hooks/useCurrentUser';
import modules from './modules';
import { BackofficeRoute } from './types/route.interfaces';
import { useSentryRoutes } from './services/Sentry';

import { WhitelabelLogin } from '@moovly/whitelabel';

interface RouterProps {
  isLoggedIn?: boolean;
}

const Router: React.FC<RouterProps> = ({ isLoggedIn }) => {
  const currentUser = useCurrentUser();

  const routes = useSentryRoutes(
    isLoggedIn
      ? [
          ...Object.values(modules).flatMap((module) => {
            const result: { path: string; element: any }[] = [];
            const checkRoutes = (routes: BackofficeRoute[]) => {
              routes.forEach((route) => {
                if (route.path) {
                  result.push({ path: route.path, element: route.element });
                }
                if (route.children) {
                  checkRoutes(route.children);
                }
              });
            };
            checkRoutes(typeof module.routes === 'function' ? module.routes(currentUser) : module.routes);
            return result;
          }),
          {
            path: '*',
            element: <Navigate replace to={`/dashboard`} />,
          },
        ]
      : [
          {
            path: '/login',
            element: <WhitelabelLogin />,
          },
          {
            path: '*',
            element: <Navigate replace to={`/login`} />,
          },
        ]
  );

  if (isLoggedIn) return <DashboardContainer>{routes}</DashboardContainer>;
  return routes;
};

export default Router;
